

window.onload = function() {
    require('./../bootstrap.js');
    require('./../owl.carousel.min.js');
    require('owl.carousel2.thumbs');
    require('jquery-mask-plugin');
    require('selectize');
    require('lightgallery');
    require('lg-fullscreen');

    // Опции в зависимости от субдомена
    let expertiseKind,
        addressCoords,
        clusterColor,
        iconImageSize;

    if (domain == 'fire') {
        expertiseKind = 'Пожарная экспертиза';
        addressCoords = '/images/fire/coords.png';
        clusterColor = '#c89248';
        clusterImageHrefNotActive = '/images/fire/flame-question-orange-small.png';
        clusterImageHrefActive = '/images/fire/flame-question-orange-small.png';
        iconImageSize = [15,19];
    } else if (domain == 'computer') {
        expertiseKind = 'Компьютерная экспертиза';
        addressCoords = '/images/computer/coords.png';
        clusterColor = '#C89248';
        clusterImageHrefNotActive = '/images/computer/examination_coords.png';
        clusterImageHrefActive = '/images/computer/examination_coords.png';
        iconImageSize = [15,21];
    } else if (domain == 'electric') {
        expertiseKind = 'Электротехническая экспертиза';
        addressCoords = '/images/electric/coords.png';
        clusterColor = '#C89248';
        clusterImageHrefNotActive = '/images/electric/examination_coords.png';
        clusterImageHrefActive = '/images/electric/examination_coords.png';
        iconImageSize = [15,19];
    } else if (domain == 'engineering') {
        expertiseKind = 'Инженернотехническая экспертиза';
        addressCoords = '/images/electric/coords.png';
        clusterColor = '#C89248';
        clusterImageHrefNotActive = '/images/electric/examination_coords.png';
        clusterImageHrefActive = '/images/electric/examination_coords.png';
        iconImageSize = [15,19];
    }  else if (domain == 'auto') {
        expertiseKind = 'Автотехническая экспертиза';
        addressCoords = '/images/electric/coords.png';
        clusterColor = '#C89248';
        clusterImageHrefNotActive = '/images/electric/examination_coords.png';
        clusterImageHrefActive = '/images/electric/examination_coords.png';
        iconImageSize = [15,19];
    }

    // Функционал выбора города
    require('./../partials/city_selection')().run();

    // Маска для телефонов
    $('.input-phone').mask('+7 (000) 000-00-00');

    // Получим изображения экспертиз для галереи либо информацию по кейсам
    require('./../partials/galleries_and_examination_details')(expertiseKind).run();

    // Вопрос-ответ
    $('body').on('show.bs.collapse', function(event) {
        if (domain == 'fire') {
            $('#' + event.target.id).closest('.question').find('.src').attr('src','/images/fire/flame-question-orange-small.png');
            $('#' + event.target.id).closest('.question').find('.row').attr('src','/images/electric/faq_close.png');
        } else if (domain == 'computer') {
            $('#' + event.target.id).closest('.question').find('.src').attr('src','/images/computer/faq_active.png');
            $('#' + event.target.id).closest('.question').find('.row').attr('src','/images/electric/faq_close.png');
        } else if (domain == 'electric') {
            $('#' + event.target.id).closest('.question').find('.src').attr('src','/images/electric/faq_active.png');
            $('#' + event.target.id).closest('.question').find('.row').attr('src','/images/electric/faq_close.png');
        } else if (domain == 'engineering') {
            $('#' + event.target.id).closest('.question').find('.src').attr('src','/images/electric/faq_active.png');
            $('#' + event.target.id).closest('.question').find('.row').attr('src','/images/electric/faq_close.png');
        } else if (domain == 'auto') {
            $('#' + event.target.id).closest('.question').find('.src').attr('src','/images/electric/faq_active.png');
            $('#' + event.target.id).closest('.question').find('.row').attr('src','/images/electric/faq_close.png');
        }
    });
    $('body').on('hide.bs.collapse', function(event) {
        if (domain == 'fire') {
            $('#' + event.target.id).closest('.question').find('.src').attr('src','/images/fire/flame-question-gray-small.png');
            $('#' + event.target.id).closest('.question').find('.row').attr('src','/images/electric/faq_open.png');
        } else if (domain == 'computer') {
            $('#' + event.target.id).closest('.question').find('.src').attr('src','/images/computer/faq_not_active.png');
            $('#' + event.target.id).closest('.question').find('.row').attr('src','/images/electric/faq_open.png');
        } else if (domain == 'electric') {
            $('#' + event.target.id).closest('.question').find('.src').attr('src','/images/electric/faq_not_active.png');
            $('#' + event.target.id).closest('.question').find('.row').attr('src','/images/electric/faq_open.png');
        } else if (domain == 'engineering') {
            $('#' + event.target.id).closest('.question').find('.src').attr('src','/images/electric/faq_not_active.png');
            $('#' + event.target.id).closest('.question').find('.row').attr('src','/images/electric/faq_open.png');
        } else if (domain == 'auto') {
            $('#' + event.target.id).closest('.question').find('.src').attr('src','/images/electric/faq_not_active.png');
            $('#' + event.target.id).closest('.question').find('.row').attr('src','/images/electric/faq_open.png');
        }
    });

    // После загрузки FAQ сделаем первый блок раскрытым
    $('.popular-question .question:first').click();
    if (domain == 'fire') {
        $('.popular-question .question:first').find('.src').attr('src','/images/fire/flame-question-orange-small.png');
        $('.popular-question .question:first').find('.row').attr('src','/images/electric/faq_close.png');
    }
    if (domain == 'computer') {
        $('.popular-question .question:first').find('.src').attr('src','/images/computer/faq_active.png');
        $('.popular-question .question:first').find('.row').attr('src','/images/electric/faq_close.png');
    }
    if (domain == 'electric') {
        $('.popular-question .question:first').find('.src').attr('src','/images/electric/faq_active.png');
        $('.popular-question .question:first').find('.row').attr('src','/images/electric/faq_close.png');
    }
    if (domain == 'engineering') {
        $('.popular-question .question:first').find('.src').attr('src','/images/electric/faq_active.png');
        $('.popular-question .question:first').find('.row').attr('src','/images/electric/faq_close.png');
    }

    // Формы в модальных окнах
    require('./../partials/modals_forms')(
        expertiseKind
    ).run();

    // Функционал закрытия модальных окон
    require('./../partials/close_modals')().run();

    // Попап пульсирующей трубки
    require('./../partials/pulse_phone')().run();

    // Отправка форм в amoCRM
    $('body').on('click', '.form-action', function(event) {
        event.preventDefault();
        let formName = $(this).closest('.form').find('.form-name');
        let phoneField = $(this).closest('.form').find('.phone');
        let notCall = $(this).closest('.form').find('.not-call');
        if ($(phoneField).val().length < 18) {
            $(phoneField).attr('style','border: 1px solid red;');
        } else {
            setInterval(function() {
                if (parseInt($('.timer').data('timer')) > 1) {
                    let timer = parseInt($('.timer').data('timer')) - 1;
                    $('.timer').text(timer);
                    $('.timer').data('timer',timer);
                } else {
                    $('.timer').text('Получить консультацию');
                }
            },1000);
            // Если форма в модальном окне, закрываем модальное окно
            $('.features-link-modal').hide(300);
            // Далее пошел ajax запрос
            let question = $(this).closest('.form').find('.question');
            axios.post('/form_data', {
                phone: $(phoneField).val(),
                question: $(question).val(),
                not_call: notCall.length ? notCall.val() : 0,
                kind: expertiseKind,
                type: 'toAmo',
                city: $('#current-city-value').text(),
                site: domain,
                form_name: $(formName).val()
            });

            $(phoneField).attr('style','');
            setTimeout(function() {
                $('#after-submitting-form').css('display','block');
            },500);
            setTimeout(function() {
                // Закроем попап
                $('#after-submitting-form').fadeOut(300);
                $('.pulse-popup').hide(300);
                setTimeout(function() {
                    $('.pulse').css('display','flex');
                },300);
                $('.input-phone').val('');
                $('.form').val('');
                $('.question').val('');
                // Закроем все модалки
                $('.city-selection-modal-content .close-button').click();
            }, 4000);
        }
    });

    // Кнопки подробнее во features открывающие модальные окна
    $('body').on('click', '.features .link', function() {
        $('.features-link-modal-' + $(this).data('number')).css('display','block');
    });

    // Модальное окно типов экспертиз
    $('body').on('click','[class^="expertise-type-1"]',function() {
        $('.features-link-modal-general-1').css('display','block');
    });
    $('body').on('click','[class^="expertise-type-2"]',function() {
        $('.features-link-modal-general-2').css('display','block');
    });
    $('body').on('click','[class^="expertise-type-3"]',function() {
        $('.features-link-modal-general-3').css('display','block');
    });
    $('body').on('click','[class^="expertise-type-4"]',function() {
        $('.features-link-modal-general-4').css('display','block');
    });

    // Плавная прокрутка к блокам
    $('body').on("click",".smooth-nav a", function (event) {
    event.preventDefault();
    let id  = $(this).attr('href'),
        top = $(id).offset().top - 68;
    $('body,html').animate({scrollTop: top}, 1500);
    });

    // Закрыть экспертизу в мобильной версии
    $('body').on("click",".case-info-wrapper .close-button", function () {
        $('.case-info-wrapper').hide(200);
    });
    $('body').on("click",".case-info .close", function () {
        $('.case-info-wrapper').hide(200);
    });

    // Слайдер кейсов в интро
    $(".intro-cases").owlCarousel({
        autoWidth:false,
        items: 1,
        mouseDrag: false,
        touchDrag: true,
        nav: false,
        dots: false,
        loop:true,
        autoplay: false,
        margin: 20,
        responsiveRefreshRate: 200
    });
    // Кнопки слайдера кейсов в интро
    $('body').on('click', '.intro-cases-slides-buttons .next', function() {
        let owl = $('.intro-cases');
        owl.owlCarousel().trigger('next.owl.carousel');
    });
    $('body').on('click', '.intro-cases-slides-buttons .prev', function() {
        let owl = $('.intro-cases');
        owl.owlCarousel().trigger('prev.owl.carousel');
    });

    // Слайдер "Наши клиенты"
    $(".our-clients-carousel").owlCarousel({
        autoWidth:false,
        mouseDrag: true,
        touchDrag: true,
        nav: false,
        dots: false,
        loop:true,
        autoplay: true,
        margin: 15,
        responsiveRefreshRate: 200,
        responsive: {
            0: {
                items: 1
            },
            450: {
                items: 2
            },
            750: {
                items: 3
            },
            950: {
                items: 5
            }
        }
    });
    // Кнопки слайдера "Наши клиенты"
    $('body').on('click', '.our-clients .next', function() {
        let owl = $('.our-clients-carousel');
        owl.owlCarousel().trigger('next.owl.carousel');
    });
    $('body').on('click', '.our-clients .prev', function() {
        let owl = $('.our-clients-carousel');
        owl.owlCarousel().trigger('prev.owl.carousel');
    });

    // Кнопки слайдера "Наши клиенты"
    $('body').on('click', '.our-experts .next', function() {
        let owl = $('.experts-electric-carousel');
        owl.owlCarousel().trigger('next.owl.carousel');
    });
    $('body').on('click', '.our-experts .prev', function() {
        let owl = $('.experts-electric-carousel');
        owl.owlCarousel().trigger('prev.owl.carousel');
    });

    // Слайдер грамот
    $(".letters-carousel").owlCarousel({
        autoWidth:true,
        mouseDrag: false,
        touchDrag: true,
        nav: false,
        dots: true,
        loop:true,
        autoplay: true,
        margin: 25,
        responsiveRefreshRate: 200
    });
    // Кнопки слайдера грамот
    $('body').on('click', '.letters .next', function() {
        let owl = $('.letters-carousel');
        owl.owlCarousel().trigger('next.owl.carousel');
    });
    $('body').on('click', '.letters .prev', function() {
        let owl = $('.letters-carousel');
        owl.owlCarousel().trigger('prev.owl.carousel');
    });

    // Фильтрация кейсов по судебной экспертизе
    $('body').on('click', '#is-court-type-button', function() {
        $(this).removeClass('action-button-outline').addClass('action-button');
        $('#is-not-court-type-button').removeClass('action-button').addClass('action-button-outline');
        $('.cases-carousel').owlCarousel().trigger('destroy.owl.carousel');
        $('.cases-carousel').html($('#court-type').html());
        $('.cases-carousel').owlCarousel({
            autoWidth:true,
            mouseDrag: true,
            touchDrag: true,
            nav: false,
            dots: true,
            loop:true,
            autoplay: false,
            margin: 20,
            responsiveRefreshRate: 200
        });
    });

    // Фильтрация кейсов по досудебной экспертизе
    $('body').on('click', '#is-not-court-type-button', function() {
        $(this).removeClass('action-button-outline').addClass('action-button');
        $('#is-court-type-button').removeClass('action-button').addClass('action-button-outline');
        $('.cases-carousel').owlCarousel().trigger('destroy.owl.carousel');
        $('.cases-carousel').html($('#not-court-type').html());
        $('.cases-carousel').owlCarousel({
            autoWidth:true,
            mouseDrag: true,
            touchDrag: true,
            nav: false,
            dots: true,
            loop:true,
            autoplay: false,
            margin: 20,
            responsiveRefreshRate: 200
        });
    });

    // Кнопки слайдера "Наши кейсы"
    $('body').on('click', '.our-cases .next', function() {
        let owl = $('.cases-carousel');
        owl.owlCarousel().trigger('next.owl.carousel');
    });
    $('body').on('click', '.our-cases .prev', function() {
        let owl = $('.cases-carousel');
        owl.owlCarousel().trigger('prev.owl.carousel');
    });

    // Слайдер экспертов электротех
    $(".experts-electric-carousel").owlCarousel({
        autoWidth:false,
        autoHeight:true,
        mouseDrag: true,
        touchDrag: true,
        nav: false,
        dots: true,
        loop:true,
        autoplay: false,
        margin: 0,
        responsiveRefreshRate: 200,
        responsive: {
            0: {
                items: 1
            }
        }
    });

    // Применим фильтр кейсов
    $('#is-not-court-type-button').click()
    $('.slides-buttons').removeClass('d-none');

    // Яндекс карта
    require('./../partials/yandex_map')(
        addressCoords,
        clusterColor,
        iconImageSize,
        clusterImageHrefActive,
    ).run();
};
